/* eslint-disable */
const mutations = {
    setSideMenu(state,payload){
        state.currentStep = payload
    }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js